<template>
  <div class="questionnaire-question">
    <Icon
      v-if="history.length > 2"
      class="questionnaire__icon-back"
      icon="ui-arrow-left"
      @click="comeBack"
    />
    <template v-if="question">
      <div
        v-if="question.slug === 'business'"
        class="questionnaire__header"
      >
        <div class="questionnaire__title -min-margin-">
          Давай познакомимся поближе?
        </div>
        <div class="questionnaire__description">
          Пройди небольшой тест, чтобы мы узнали о&nbsp;Тебе немного больше
        </div>
      </div>
      <div class="questionnaire-question__title">
        {{ title }}
      </div>
      <component
        :is="type.type !== 'long-text' ? 'AllType' : 'LongText'"
        v-if="!isSendQuestion && type.type !== 'double'"
        :key="activeQuestionId"
        v-model="value"
        :display="type.display"
        :type="type.type"
        :advancedClass="!noLimiter ? 'questionnaire__limiter' : ''"
        :option="option"
        @inputText="inputText"
      />
      <QuestionLoader
        v-if="isSendQuestion"
        :display="type.display"
        :type="type.type"
        :class="{'questionnaire__limiter': !noLimiter}"
        :option="option"
      />
      <DoubleNumberForm
        v-if="!isSendQuestion && question.slug === 'month_revenue_profit'"
        :key="activeQuestionId"
        :additional-title="question.additionalTitle"
        :display="type.display"
        :type="type.type"
        :class="{'questionnaire__limiter': !noLimiter}"
        :revenue="revenue"
        :profit="profit"
        @input-revenue="revenue = $event"
        @input-profit="profit = $event"
      />
      <RevenueProfitHelper
        v-if="!isSendQuestion && question.slug === 'month_revenue_profit_help'"
      />
      <div
        v-if="question.slug === 'month_revenue_profit'"
        class="questionnaire-content__block -margin-l-"
      >
        <p
          class="questionnaire-content__link"
          @click="revenueHelp"
        >
          Как посчитать выручку и прибыль
        </p>
      </div>
      <UiButton
        v-if="question.slug !== 'month_revenue_profit_help'"
        :disabled="!valid"
        @click="send"
      >
        Продолжить
      </UiButton>
    </template>
  </div>
</template>

<script>
import LongText from './type/LongText';
import AllType from './type/AllType';
import QuestionLoader from './type/QuestionLoader';
import DoubleNumberForm from './type/DoubleNumberForm';
import RevenueProfitHelper from './RevenueProfitHelper';

import { mapGetters, mapState } from 'vuex';
import { isNumber } from 'lodash';

export default {
  components: {
    LongText,
    QuestionLoader,
    AllType,
    DoubleNumberForm,
    RevenueProfitHelper
  },
  props: {
    button: {}
  },
  data: () => ({
    value: '',
    revenue: undefined,
    profit: undefined,
    valid: false,
    forceIsNotVariant: false
  }),
  computed: {
    ...mapGetters('questionnaire', {
      question: 'activeQuestion'
    }),
    ...mapState('questionnaire', {
      questionList: s => s.data.questionList,
      activeQuestionId: s => s.data.activeQuestionId,
      isSendQuestion: s => s.meta.isSendQuestion,
      history: s => s.data.history,
      hundredWasForced: s => s.data.hundredWasForced
    }),
    title() {
      return this.question.title;
    },
    option() {
      return this.question.variants;
    },
    type() {
      if (!this.question) {
        return {
          display: 'grid',
          type: 'square'
        };
      }

      if (
        this.question.slug === 'month_revenue_profit' ||
        this.question.slug === 'month_revenue_profit_help'
      ) {
        return {
          display: 'grid',
          type: 'double'
        };
      }

      const length = this.option.length;

      if (!length) {
        return { display: 'grid', type: 'long-text' };
      }

      if (length < 4) {
        return {
          display: 'grid',
          type: 'one'
        };
      }

      if (this.question.slug === 'leader') {
        return {
          display: 'flex',
          type: 'big-square-odd'
        };
      }

      // Особое условие
      // Если вариантов ответа 4
      // и первый ответ огромный
      if (length === 4 && this.option[0].title.length > 20) {
        return {
          display: 'grid',
          type: 'big-square'
        };
      }

      if (length === 4) {
        return {
          display: 'grid',
          type: 'square'
        };
      }

      if (length < 7) {
        return {
          display: 'flex',
          type: 'triple'
        };
      }

      if (length === 11) {
        return {
          display: 'flex',
          type: 'business-categories'
        };
      }

      return {
        display: 'flex',
        type: 'square'
      };
    },
    noLimiter() {
      if (!this.option.length) {
        return false;
      }
      // Если вариантов ответа много
      if (this.option.length > 4) {
        return true;
      }
      // Если вариантов ответа 4
      // и первый ответ огромный
      return this.option.length > 3 && this.option[0].title.length > 20;
    },
    selectOption() {
      if (!this.option.length) {
        return {};
      }

      if (this.type.type === 'long-text') {
        return this.option[0];
      }

      return this.option.find(({ id }) => id === this.value);
    },
    userAnswer() {
      return (
        (this.question.variants.length > 1
          ? this.question.answer?.variant
          : this.question.answer?.text) ?? ''
      );
    },
    nextQuestion() {
      if (this.selectOption && this.selectOption.nextQuestion) {
        return this.selectOption.nextQuestion;
      }
      return this.question.nextQuestion;
    }
  },
  watch: {
    userAnswer(value) {
      this.value = value || '';
    },
    value() {
      this.validateForm();
    },
    revenue() {
      this.validateForm();
    },
    profit() {
      this.validateForm();
    }
  },
  mounted() {
    this.value = this.userAnswer;
  },
  methods: {
    inputText(value) {
      this.value = value
      this.forceIsNotVariant = true
    },
    validateForm() {
      if (this.question.slug === 'month_revenue_profit') {
        this.valid =
          isNumber(this.profit) && isNumber(this.revenue) && this.profit >= 0 && this.revenue >= 0;
      } else {
        this.valid = this.value !== '';
      }
    },
    async send() {
      const res =
        this.question.slug === 'month_revenue_profit'
          ? await this.sendPointA()
          : await this.sendQuestion();
      if (res.status === 'success') {
        // Нужно что бы сохранить навигацию при нажатии кнопки назад из регистрации телеги
        const toggleCourseId = this.questionList.find(q => q.slug === 'select_course')?.id ?? 0;
        if (res.forceHundred) {
          await this.$store.dispatch('questionnaire/hundredReplace');
          return;
        }
        if (this.nextQuestion === toggleCourseId) {
          this.$router.push('/questionnaire/toggle-course');
          return;
        } else if (this.nextQuestion === null && this.hundredWasForced) {
          this.$router.push('/questionnaire/hundred');
        } else if (this.nextQuestion === null) {
          this.$router.push('/questionnaire/telegram');
          return;
        }
        await this.$store.dispatch('questionnaire/setQuestion', this.nextQuestion);

        this.clearValue();
      }
    },
    clearValue() {
      // Не уверен, что это нужно, но если value совпадает с тем,
      // что пользователь уже выбрал, то не чистим
      if (
        !this.question ||
        (this.question.variants.length > 1
          ? this.question.answer?.variant
          : this.question.answer?.text) !== this.value
      ) {
        this.value = '';
      }
    },
    async sendPointA() {
      return await this.$store.dispatch('questionnaire/sendPointA', {
        revenue: this.revenue,
        profit: this.profit
      });
    },
    async sendQuestion() {
      let params = {
        id: this.activeQuestionId,
        value: this.value,
        isVariant: false
      }
      if (!this.forceIsNotVariant) {
        params.isVariant = this.question.variants.length > 1
      }
      this.forceIsNotVariant = false
      return await this.$store.dispatch('questionnaire/sendQuestion', params);
    },
    comeBack() {
      if (this.isSendQuestion) {
        return;
      }
      this.$store.dispatch('questionnaire/comeBackHistory');
    },
    revenueHelp() {
      this.$store.dispatch('questionnaire/setQuestion', this.question.helpPage);
    }
  }
};
</script>
